import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CloseIconSmall = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Close Icon Small`} {...props}>
    <Path
      d="M5 5L11 11"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <Path
      d="M5 11L11 5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </Icon>
);
